import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import toast, { Toaster } from "react-hot-toast";
import { CONSTANTS } from "../shared/constants";

const ConnectWalletBtn = (info) => {
	const [isWalletConnected, setIsWalletConnected] = useState(false);
	const [walletAddress, setWalletAddress] = useState("");
	const [network, setNetwork] = useState(0);

	// Function to connect to MetaMask wallet
	const connectWallet = async () => {
		try {
			// Request account access from MetaMask
			await window.ethereum.request({ method: "eth_requestAccounts" });

			// Create an ethers.js provider for the connected wallet
			const provider = new ethers.providers.Web3Provider(window.ethereum);

			// Get the signer (account) from the provider
			const signer = provider.getSigner();

			// Get the wallet address
			const address = await signer.getAddress();

			const chainId = await provider
				.getNetwork()
				.then((network) => network.chainId);

			// Update the state with the connected wallet address
			setWalletAddress(address);
			setIsWalletConnected(true);
			setNetwork(chainId);
			localStorage.setItem("wallet_connection", true);
			localStorage.setItem("wallet_address", address);
			localStorage.setItem("chain_id", chainId);

			if (info.source == "stake") {
				if (chainId !== CONSTANTS.STAKE_NETWORK_ID) {
					toast.dismiss();
					toast.error(
						`Incorrect network, Please switch network to ${CONSTANTS.STAKE_NETWORK_NAME}`
					);
					setWalletAddress("");
					setIsWalletConnected(false);
					setNetwork(0);
					localStorage.removeItem("wallet_connection", false);
					localStorage.removeItem("wallet_address", "");
					localStorage.removeItem("chain_id", 0);
					return;
				}
			} else if (info.source == "rewards") {
				if (chainId !== CONSTANTS.CLAIM_NETWORK_ID) {
					toast.dismiss();
					toast.error(
						`Incorrect network, Please switch network to ${CONSTANTS.CLAIM_NETWORK_NAME}`
					);
					setWalletAddress("");
					setIsWalletConnected(false);
					setNetwork(0);
					localStorage.removeItem("wallet_connection", false);
					localStorage.removeItem("wallet_address", "");
					localStorage.removeItem("chain_id", 0);
					return;
				}
			}
			reloadPage();
		} catch (error) {
			console.error(error);
			setWalletAddress("");
			setIsWalletConnected(false);
			setNetwork(0);
			localStorage.removeItem("wallet_connection", false);
			localStorage.removeItem("wallet_address", "");
			localStorage.removeItem("chain_id", 0);
		}
	};

	// Function to disconnect the wallet
	const disconnectWallet = () => {
		setWalletAddress("");
		setIsWalletConnected(false);
		setNetwork(0);
		localStorage.removeItem("wallet_connection", false);
		localStorage.removeItem("wallet_address", "");
		localStorage.removeItem("chain_id", 0);
		reloadPage();
	};

	useEffect(() => {
		let wallet_connection = localStorage.getItem("wallet_connection");
		let wallet_address = localStorage.getItem("wallet_address");
		let chain_id = localStorage.getItem("chain_id");
		setIsWalletConnected(wallet_connection);
		setWalletAddress(wallet_address);
		setNetwork(chain_id);
	});

	function trimWalletAddress(wallet) {
		if (wallet != null) {
			return `${wallet.substring(0, 6)}...${wallet.substring(35, 42)}`;
		}
	}

	function reloadPage() {
		window.location.reload();
	}

	return (
		<div className="text-center">
			<Toaster position="top-right" />
			{!isWalletConnected ? (
				<button
					onClick={connectWallet}
					className="text-center connect-wallet-btn btn btn-pink"
				>
					<p>Connect Wallet</p>
				</button>
			) : (
				<button
					onClick={disconnectWallet}
					className="text-center connect-wallet-btn btn btn-pink"
				>
					<p>
						<small>{trimWalletAddress(walletAddress)}</small>
						<span title="Disconnect Wallet">X</span>
					</p>
				</button>
			)}
			{!isWalletConnected && (
				<>
					{info.source === "rewards" ? (
						<p className="text-white mb-small">
							Please make sure you are connected to Avalanche network to claim
							the rewards
						</p>
					) : (
						<p className="text-white mb-small">
							Please change your network to {CONSTANTS.STAKE_NETWORK_NAME} while
							staking & {CONSTANTS.CLAIM_NETWORK_NAME} while claiming rewards.
						</p>
					)}
				</>
			)}
		</div>
	);
};

export default ConnectWalletBtn;
